import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import Label from '../Label';
import { classNames } from 'primereact/utils';

const FormikDropdown = (props) => {
  const { labelText, isMandatory = false, formik, name, className, onChange, ...rest } = props;

  const isInvalid = !!(formik.touched[name] && formik.errors[name]);
  const mergeClassName = classNames(className, {
    'p-invalid': isInvalid
  });
  return (
    <>
      {labelText && <Label htmlFor={name} text={labelText} isMandatory={isMandatory} />}
      <Dropdown
        {...rest}
        id={name}
        name={name}
        value={formik.values[name]}
        onChange={(e) => {
          formik.setFieldValue(name, e.value, true);
          if (onChange) onChange(e);
        }}
        onBlur={(e) => {
          formik.handleBlur(e);
          if (rest.onBlur) rest.onBlur(e);
        }}
        className={mergeClassName}
        panelClassName="custom-dropdown-panel"
      />
      {isInvalid && <small className="p-error">{formik.errors[name]}</small>}
    </>
  );
};

export default FormikDropdown;
